module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CN-dd203ec8b2bee6ecf30fb4cee6b05c5a.png";